const artistStyles = {
  imgCarousel: {
    height: "75%",
    width: "100%"
  },

  bioText: {
    margin: 10
  }
};

export default artistStyles;



// WEBPACK FOOTER //
// ./src/views/Artists/Styles/ArtistStyles.jsx